import { fetchApi } from '@/config/axiosSetting';
import { DeleteSubstitutionPartParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteSubstitutionPart/deleteSubstitutionPartQueryOption.type';

export const deleteAccessoryQueryFunction = (
  params: DeleteSubstitutionPartParamsType,
) => {
  return fetchApi.delete(`/initial/reports/${params.id}/accessory/`, {
    params,
  });
};
